var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      ref: "form",
      staticClass: "col-12",
      attrs: { id: "account-preferences-form" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.handleInitialSubmit.apply(null, arguments)
        },
        change: _vm.handleFormChange,
      },
    },
    [
      _c("div", { staticClass: "card" }, [
        _c("ul", { staticClass: "list-group list-group-flush" }, [
          _c("li", { staticClass: "list-group-item" }, [
            _c("h6", { staticClass: "grey-text text-darken-3 m-0" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("settings.accountTab.accountPreferences")) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-group-item" }, [
            _c("div", { staticClass: "settings-container mx-0 col-lg-10" }, [
              _c("div", { staticClass: "row moregage-form pretty-custom" }, [
                _c("div", { staticClass: "col-8 col-md-9 col-lg-10" }, [
                  _c(
                    "p",
                    {
                      staticClass:
                        "bold text-regular-gray font-sm mb-2 mb-lg-0",
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("settings.accountTab.showTutorial")) +
                          "\n              "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-2 my-auto text-right" }, [
                  _c(
                    "div",
                    { staticClass: "pretty p-bigger p-switch p-fill" },
                    [
                      _c(
                        "label",
                        { staticClass: "text-regular-gray label-before" },
                        [_vm._v(_vm._s(_vm.$t("global.words.no")))]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.tutorial,
                            expression: "tutorial",
                          },
                        ],
                        attrs: {
                          id: "tutorial",
                          name: "tutorial",
                          type: "checkbox",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.tutorial)
                            ? _vm._i(_vm.tutorial, null) > -1
                            : _vm.tutorial,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.tutorial,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.tutorial = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.tutorial = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.tutorial = $$c
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "tutorial", hidden: "" } }, [
                        _vm._v("Tutorial"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "state" }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("global.words.yes"))),
                        ]),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row moregage-form pretty-custom" }, [
                _c("div", { staticClass: "col-8 col-md-9 col-lg-10" }, [
                  _c(
                    "p",
                    {
                      staticClass:
                        "bold text-regular-gray font-sm mb-2 mb-lg-0",
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t("settings.accountTab.includeExisting")
                          ) +
                          "\n              "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-2 my-auto text-right" }, [
                  _c(
                    "div",
                    { staticClass: "pretty p-bigger p-switch p-fill" },
                    [
                      _c(
                        "label",
                        { staticClass: "text-regular-gray label-before" },
                        [_vm._v(_vm._s(_vm.$t("global.words.no")))]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.includeExisting,
                            expression: "includeExisting",
                          },
                        ],
                        attrs: {
                          id: "includeExisting",
                          name: "includeExisting",
                          type: "checkbox",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.includeExisting)
                            ? _vm._i(_vm.includeExisting, null) > -1
                            : _vm.includeExisting,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.includeExisting,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.includeExisting = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.includeExisting = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.includeExisting = $$c
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { attrs: { for: "includeExisting", hidden: "" } },
                        [_vm._v("Include Existing Mortgages")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "state" }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("global.words.yes"))),
                        ]),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }